import type { ReportsMessageId } from "./reports.fr";

/** Signalements in Italian. Same keys and {placeholders} as reports.fr.ts. */
export const reportsIt: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "Gravità",
  "reports.filter.status": "Stato",
  "reports.filter.all": "Tutti",
  "reports.filter.reviewOverdue": "Revisione della sospensione in ritardo",
  "reports.list.loading": "Caricamento delle segnalazioni…",
  "reports.list.loadFailed": "Impossibile caricare le segnalazioni.",
  "reports.list.empty": "Nessuna segnalazione per questi filtri.",
  "reports.list.aria": "Segnalazioni",
  "reports.list.by": "segnalato da {name}",
  "reports.list.aboutSubject": "{count} segnalazioni su questa persona",
  "reports.pick": "Scegli una segnalazione dall'elenco.",
  "reports.loading": "Caricamento della segnalazione…",
  "reports.loadFailed": "Impossibile caricare questa segnalazione.",
  "reports.notFound": "Questa segnalazione non si trova. Ricarica l'elenco.",
  "reports.refreshFailed": "Non è stato possibile aggiornare la segnalazione: è mostrata com'era.",
  "reports.dismiss": "Chiudi",

  "reports.severity.critical": "Critica",
  "reports.severity.high": "Alta",
  "reports.severity.medium": "Media",
  "reports.severity.low": "Bassa",
  "reports.status.open": "Aperta",
  "reports.status.investigating": "In indagine",
  "reports.status.decided": "Decisa",
  "reports.status.appealed": "In appello",
  "reports.status.closed": "Chiusa",
  "reports.verdict.none": "Nessuna sanzione",
  "reports.verdict.warning": "Avvertimento",
  "reports.verdict.temporary_suspension": "Sospensione temporanea",
  "reports.verdict.permanent_ban": "Esclusione definitiva",
  "reports.appeal.upheld": "Decisione confermata",
  "reports.appeal.overturned": "Decisione annullata",
  "reports.source.app": "Dall'app",
  "reports.source.phone": "Per telefono",
  "reports.source.console": "Aperta dal team",

  "reports.category.assault": "Aggressione",

  "reports.new.title": "Nuova segnalazione",

  "reports.new.source": "Come è arrivata",

  "reports.new.byPhone": "Per telefono",

  "reports.new.byStaff": "Rilevata dal team",

  "reports.new.subject": "Chi viene segnalato",

  "reports.new.reporter": "Chi ha segnalato",

  "reports.new.reporterHint":
    "Il suo identificativo, se ha segnalato un cliente. Lascia vuoto se l'ha rilevata il team.",

  "reports.new.category": "Che cosa è successo",

  "reports.new.categoryHint": "La gravità deriva da questo. Modificabile in seguito.",

  "reports.new.description": "Che cosa ci è stato detto",

  "reports.new.descriptionHint": "Con le sue parole, quando possibile. Lo legge chi indaga.",

  "reports.new.submit": "Apri la segnalazione",

  "reports.new.needSubject": "Scegli chi viene segnalato.",

  "reports.new.needDescription": "Descrivi che cosa è successo, almeno in una frase.",

  "reports.new": "Nuova segnalazione",
  "reports.category.sexual_violence": "Violenza sessuale",
  "reports.category.serious_theft": "Furto grave",
  "reports.category.weapon_threat": "Minaccia con un'arma",
  "reports.category.theft": "Furto",
  "reports.category.threats": "Minacce",
  "reports.category.harassment": "Molestie",
  "reports.category.fraud": "Frode",
  "reports.category.unsafe_work": "Lavoro pericoloso",
  "reports.category.no_show": "Assenza all'appuntamento",
  "reports.category.other": "Altro",

  "reports.pill.suspended": "Sospeso",
  "reports.pill.reviewOverdue": "Revisione in ritardo",
  "reports.pill.legalHold": "Blocco legale",

  "reports.detail.versionTitle": "La versione della segnalazione mostrata: ogni azione la invia.",
  "reports.detail.critical": "Segnalazione critica",
  "reports.detail.needsPolice": "Non è ancora stata trasmessa alla polizia. I proprietari sono stati avvisati.",
  "reports.detail.subject": "Persona segnalata",
  "reports.detail.reporter": "Autore della segnalazione",
  "reports.detail.openedBy": "Aperta da {name}",
  "reports.detail.noReporter": "Sconosciuto",
  "reports.detail.job": "Richiesta collegata",
  "reports.detail.case": "Pratica di origine",
  "reports.detail.subjectCase": "Pratica della persona segnalata",
  "reports.detail.openCase": "Apri la pratica →",
  "reports.detail.noSubjectCase": "Nessuna: si apre con la sospensione o l'appello",
  "reports.detail.none": "Nessuno",
  "reports.detail.description": "Cosa è successo",
  "reports.detail.restrictions": "Sospensioni ed esclusioni",
  "reports.detail.restrictionsHint":
    "Una sospensione dura fino a una decisione del team. Il termine di revisione non è una scadenza: passato il termine, la persona resta sospesa e la revisione è in ritardo.",
  "reports.detail.verdict": "Verdetto",
  "reports.detail.decidedBy": "Da {name}, il {date}",
  "reports.detail.appeal": "Appello",
  "reports.detail.appealedAt": "Appello ricevuto il {date}",
  "reports.detail.appealPending": "Da decidere",
  "reports.detail.police": "Trasmissioni alla polizia",
  "reports.detail.shared": "Dati consegnati: {categories} · {name}, {date}",
  "reports.detail.holds": "Blocchi legali",
  "reports.detail.holdPlaced": "In vigore dal {date} · {name}",
  "reports.detail.holdReleased": "Revocato il {date} · {name}",
  "reports.detail.related": "Altre segnalazioni su questa persona",
  "reports.detail.timeline": "Cronologia",
  "reports.detail.actions": "Azioni",
  "reports.detail.noActions": "I tuoi ruoli non consentono alcuna azione su questa segnalazione.",

  "reports.restriction.interim_suspension": "Sospensione durante l'indagine",
  "reports.restriction.temporary_suspension": "Sospensione temporanea",
  "reports.restriction.permanent_ban": "Esclusione definitiva",
  "reports.restriction.untilDecision": "Fino a una decisione del team",
  "reports.restriction.untilDecisionReviewBy": "Fino a una decisione del team · da rivedere entro il {date}",
  "reports.restriction.until": "Fino al {date}",
  "reports.restriction.permanent": "Definitiva, salvo appello accolto",
  "reports.restriction.switchedOff": "Disattivato: {features}",
  "reports.restriction.lifted": "Revocata il {date} da {name}",
  "reports.restriction.inForce": "In vigore",
  "reports.restriction.ended": "Terminata",

  "reports.entry.report": "Segnalazione",
  "reports.entry.evidence": "Prova",
  "reports.entry.severity_changed": "Gravità modificata",
  "reports.entry.suspended": "Sospensione applicata",
  "reports.entry.suspension_lifted": "Sospensione revocata",
  "reports.entry.verdict": "Verdetto",
  "reports.entry.appeal": "Appello",
  "reports.entry.appeal_decided": "Appello deciso",
  "reports.entry.police_referral": "Trasmessa alla polizia",
  "reports.entry.police_data_shared": "Dati consegnati alla polizia",
  "reports.entry.legal_hold_placed": "Blocco legale applicato",
  "reports.entry.legal_hold_released": "Blocco legale revocato",
  "reports.entry.linked": "Collegamento aggiunto",
  "reports.entry.suspension_withheld": "Sospensione non applicata",
  "reports.entry.system": "Sistema",
  "reports.entry.evidenceLink": "Vedi la prova →",

  "reports.police.category.identity": "Identità",
  "reports.police.category.contact_details": "Recapiti",
  "reports.police.category.id_document": "Documento d'identità",
  "reports.police.category.messages": "Messaggi",
  "reports.police.category.job_details": "Dettagli della richiesta",
  "reports.police.category.report_and_evidence": "Segnalazione e prove",
  "reports.police.category.audit_log": "Registro di audit",
  "reports.police.category.payments": "Pagamenti",
  "reports.hold.entity.safety_report": "Questa segnalazione",
  "reports.hold.entity.user": "L'account",
  "reports.hold.entity.job": "La richiesta",
  "reports.hold.entity.conversation": "La conversazione",

  "reports.block.ownVerdict": "Il verdetto l'hai emesso tu: l'appello deve deciderlo un'altra persona.",
  "reports.block.ownerOnly": "Solo un proprietario può consegnare dati alla polizia.",
  "reports.block.noReferral": "Trasmetti prima la segnalazione alla polizia per annotare i dati consegnati.",

  "reports.action.evidence": "Aggiungi una prova",
  "reports.action.severity": "Cambia la gravità",
  "reports.action.suspend": "Sospendi durante l'indagine",
  "reports.action.lift": "Revoca la sospensione",
  "reports.action.verdict": "Emetti il verdetto",
  "reports.action.ban": "Escludi definitivamente",
  "reports.action.appeal": "Decidi l'appello",
  "reports.action.police": "Trasmetti alla polizia",
  "reports.action.share": "Annota dati consegnati",
  "reports.action.hold": "Applica un blocco legale",
  "reports.action.release": "Revoca il blocco legale",

  "reports.dialog.evidence.title": "Aggiungi una prova · {reference}",
  "reports.dialog.evidence.body":
    "Descrivi la prova e, se è online, indica il collegamento. Viene aggiunta alla cronologia.",
  "reports.dialog.severity.title": "Cambia la gravità · {reference}",
  "reports.dialog.severity.body":
    "Una segnalazione critica avvisa i proprietari e va trasmessa alla polizia. Indica perché la cambi.",
  "reports.dialog.suspend.title": "Sospendi · {reference}",
  "reports.dialog.suspend.body":
    "{name} non potrà più usare Walliyo, salvo contattare il team e fare appello, fino a una decisione del team. Si applica un termine di revisione: non è la fine della sospensione. La persona viene avvisata nell'app e si apre una pratica a suo nome.",
  "reports.dialog.lift.title": "Revoca la sospensione · {reference}",
  "reports.dialog.lift.body": "{name} riottiene l'accesso a Walliyo da subito. Indica il perché.",
  "reports.dialog.verdict.title": "Emetti il verdetto · {reference}",
  "reports.dialog.verdict.body":
    "{name} legge il motivo nell'app e può fare appello una volta. Nessuno viene sanzionato senza un motivo scritto.",
  "reports.dialog.ban.title": "Escludi definitivamente · {reference}",
  "reports.dialog.ban.body":
    "{name} perde l'accesso a Walliyo per sempre e il suo documento d'identità viene escluso. Il motivo gli viene mostrato nell'app; può fare appello una volta.",
  "reports.dialog.appeal.title": "Decidi l'appello · {reference}",
  "reports.dialog.appeal.body":
    "Annullata revoca ciò che il verdetto ha applicato. {name} legge il tuo motivo nell'app. Deve decidere una persona diversa dall'autore del verdetto.",
  "reports.dialog.police.title": "Trasmetti alla polizia · {reference}",
  "reports.dialog.police.body": "Annota a chi è stata trasmessa la segnalazione. Da qui non viene inviato nulla.",
  "reports.dialog.share.title": "Dati consegnati alla polizia · {reference}",
  "reports.dialog.share.body":
    "Annota esattamente cosa è stato consegnato, categoria per categoria. Questa traccia viene conservata e compare nel registro di audit.",
  "reports.dialog.hold.title": "Applica un blocco legale · {reference}",
  "reports.dialog.hold.body":
    "Nulla di ciò che riguarda questa segnalazione potrà essere eliminato finché il blocco è in vigore, nemmeno dalla regola di conservazione.",
  "reports.dialog.release.title": "Revoca il blocco legale · {reference}",
  "reports.dialog.release.body":
    "Le regole di conservazione tornano ad applicarsi a tutto ciò che il blocco proteggeva.",

  "reports.field.evidence": "La prova",
  "reports.field.evidenceUrl": "Collegamento (facoltativo)",
  "reports.field.evidenceUrlHint": "Un indirizzo https://, per esempio una foto caricata nella pratica.",
  "reports.field.severity": "Nuova gravità",
  "reports.field.verdict": "Verdetto",
  "reports.field.suspendedUntil": "Sospeso fino al",
  "reports.field.toldReason": "Motivo letto dalla persona",
  "reports.field.toldHint": "Una frase vera, con parole che la persona capisce. Almeno 10 caratteri.",
  "reports.field.decision": "Decisione",
  "reports.field.station": "Commissariato o stazione",
  "reports.field.officerName": "Nome dell'agente",
  "reports.field.officerContact": "Contatto dell'agente (facoltativo)",
  "reports.field.policeReference": "Riferimento della polizia (facoltativo)",
  "reports.field.referral": "Trasmissione",
  "reports.field.categories": "Dati consegnati",
  "reports.field.shareDescription": "Cosa è stato consegnato, esattamente",
  "reports.field.shareDescriptionHint": "Per esempio: messaggi dal 3 al 5 maggio, scansione della carta d'identità.",
  "reports.field.reasonOptional": "Motivo (facoltativo)",

  "reports.problem.reason": "Indica un motivo da {min} a {max} caratteri.",
  "reports.problem.told": "Scrivi il motivo che leggerà la persona: almeno {min} caratteri.",
  "reports.problem.evidence": "Descrivi la prova.",
  "reports.problem.url": "Il collegamento deve essere un indirizzo http:// o https:// completo.",
  "reports.problem.until": "Scegli una data di fine sospensione nel futuro.",
  "reports.problem.police": "Indica il commissariato e il nome dell'agente (da 2 a 200 caratteri ciascuno).",
  "reports.problem.referral": "Scegli la trasmissione interessata.",
  "reports.problem.categories": "Seleziona almeno una categoria di dati consegnati.",
  "reports.problem.shareDescription": "Indica esattamente cosa è stato consegnato.",

  "reports.done.evidence": "Prova aggiunta a {reference}.",
  "reports.done.severity": "Gravità di {reference} modificata.",
  "reports.done.suspend": "Persona sospesa fino a una decisione del team ({reference}). Viene avvisata nell'app.",
  "reports.done.lift": "Sospensione revocata ({reference}).",
  "reports.done.verdict": "Verdetto salvato su {reference}. La persona viene avvisata nell'app.",
  "reports.done.ban": "Esclusione salvata su {reference}. La persona viene avvisata nell'app.",
  "reports.done.appeal": "Appello deciso su {reference}. La persona viene avvisata nell'app.",
  "reports.done.police": "Trasmissione alla polizia annotata su {reference}.",
  "reports.done.share": "Dati consegnati annotati su {reference}.",
  "reports.done.hold": "Blocco legale applicato su {reference}.",
  "reports.done.release": "Blocco legale revocato su {reference}.",

  "reports.error.stale": "Questa segnalazione è cambiata mentre la guardavi. Ricaricala, controlla e ricomincia.",
  "reports.error.refused":
    "Azione rifiutata: i tuoi ruoli non includono la funzionalità necessaria. Chiedi l'accesso a un responsabile.",
  "reports.error.appealRefused":
    "Rifiutato: l'appello deve essere deciso da una persona diversa dall'autore del verdetto, con HANDLE_APPEALS.",
  "reports.error.shareRefused": "Rifiutato: solo un proprietario può consegnare dati alla polizia.",
  "reports.error.invalid":
    "Rifiutato: la segnalazione non è più nello stato previsto, oppure un campo non è valido. Ricaricala e controlla.",
  "reports.error.outcomeUnknown":
    "Nessuna risposta dal server: l'azione potrebbe essere stata salvata. Riprova: lo stesso clic non può essere applicato due volte.",

  "reports.refused.wrongStatus":
    "Rifiutato: questa segnalazione non è più a quel passaggio, l'azione non vale più. Ricaricala.",
  "reports.refused.alreadyRestricted": "Rifiutato: questa persona è già sospesa da un'altra segnalazione.",
  "reports.refused.notSuspended": "Rifiutato: questa segnalazione non ha più una sospensione in corso. Ricaricala.",
  "reports.refused.suspendedUntilRequired": "Una sospensione temporanea ha bisogno di una data di fine nel futuro.",
  "reports.refused.ownVerdict": "Rifiutato: hai emesso tu questo verdetto, quindi l'appello lo decide qualcun altro.",
  "reports.refused.alreadyHeld": "Questa segnalazione è già sotto blocco legale. Ricaricala.",
  "reports.refused.notHeld": "Questa segnalazione non è più sotto blocco legale. Ricaricala.",
};
